import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess, staticc } from "../../Components/General/Notification";

const getPackages = (users) => {
    return ({
        type: types.GET_ALL_PACKAGES,
        payload: users
    })
}

const addPackage = () => {
    return ({
        type: types.ADD_PACKAGE
    })
}

const addToVen = () => {
    return ({
        type: types.ADD_TO_VENDOR
    })
}

const delPackages = () => {
    return ({
        type: types.DELETE_PACKAGE
    })
}

const editStatusPackage = () => {
    return ({
        type: types.EDIT_STATUS_PACKAGE
    })
}

const editPackage = () => {
    return ({
        type: types.EDIT_PACKAGE
    })
}
const addFeatures = () => {
    return ({
        type: types.ADD_FEATURES
    })
}

const getFeatures = (Features) => {
    return ({
        type: types.GET_FEATURES,
        payload: Features
    })
}

const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}

const delFeatures = () => {
    return ({
        type: types.DELETE_FEATURE
    })
}

const editFeature = () => {
    return ({
        type: types.EDIT_FEATURE
    })
}

const addFeatureToVendor = () => {
    return ({
        type: types.ADD_FEATURE_TO_VENDOR
    })
}

export const loadPackages = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/packages`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getPackages(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const deletePackage = (id) => {
    return function (dispatch) {
        //setloabBtn(true)
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/package_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delPackages());
                dispatch(loadPackages());
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const editStatusPackagee = (id, is_active, setloadStatusID) => {
    return function (dispatch) {
        setloadStatusID(true)
        console.log(id)
        console.log(is_active)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/package_status`, { id, is_active }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editStatusPackage());
                dispatch(loadPackages());
                notifysuccess(res.data.message)
                setloadStatusID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadStatusID(false)
            notifyError(err.response.data)
        })
    }
}

export const postPackage = (name, name_ar, description, description_ar, price, start_date, end_date, is_active, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/package_add`, {
            name, name_ar, description, description_ar, price, start_date, end_date, is_active
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addPackage());
                dispatch(loadPackages());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const updatePackage = (id, name, name_ar, description, description_ar, price, start_date, end_date, is_active, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        console.log("-------------------------")
        console.log(id)
        console.log("-------------------------")
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/package_update`, {
            id, name, name_ar, description, description_ar, price, start_date, end_date, is_active
        }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editPackage());
                dispatch(loadPackages());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}

export const postFeatures = (package_id, name, name_ar, icon, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append("package_id", package_id)
        Dataa.append("name", name)
        Dataa.append("name_ar", name_ar)
        Dataa.append("icon", icon)
        axios.post(`${staticc}/api/feature_add`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addFeatures());
                dispatch(loadFeatures(package_id));
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadFeatures = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/features?package_id=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getFeatures(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
        })
    }
}

export const emptyOneFeatures = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(emptyGeneral(emptyy, types.EMPTY_FEATURES))
    }
}

export const deleteFeatures = (package_id, id) => {
    return function (dispatch) {
        //setloabBtn(true)
        console.log(package_id)
        console.log(id)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/feature_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delFeatures());
                dispatch(loadFeatures(package_id));
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const updateFeatures = (id, package_id, name, name_ar, icon, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        if (icon !== '') {
            Dataa.append("icon", icon)
        }
        Dataa.append("id", id)
        Dataa.append("package_id", package_id)
        Dataa.append("name", name)
        Dataa.append("name_ar", name_ar)
        axios.post(`${staticc}/api/feature_update`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(editFeature());
                dispatch(loadFeatures(package_id));
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const postAddToVen = (package_id, vendor_id, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/add_vendor_package`, { package_id, vendor_id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message === "success") {
                dispatch(addToVen());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const addFeaturestovendorr = (vendor_id, features, setloadStatusID) => {
    return function (dispatch) {
        setloadStatusID(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        Dataa.append("vendor_id", vendor_id);
        features.forEach((feature, index) => {
            Dataa.append(`features[${index}][feature_id]`, feature.feature_id);
            Dataa.append(`features[${index}][content]`, feature.content);
            Dataa.append(`features[${index}][content_ar]`, feature.content_ar);
        });
        axios.post(`${staticc}/api/add_vendor_features`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addFeatureToVendor());
                notifysuccess(res.data.message)
                setloadStatusID(false)
            }
        }).catch((err) => {
            console.log(err)
            setloadStatusID(false)
            notifyError(err.response.data.message)
        })
    }
}